<table class="{{table_class}}">
  <tr class="results-headers">
    {{#each columns}}
      <th>{{t this}}</th>
    {{/each}}
  </tr>
  {{#each results}}
    <tr>
      {{#each this}}
        <td>{{this}}</td>
      {{/each}}
    </tr>
  {{/each}}
</table>